import { createSlot } from "lib/@components/slot/create-slot"
import { AuthoringTaskItem } from "./authoring-task-item"
import { Bound } from "lib/@components/binding/Bound"
import { TabledRepeat } from "lib/@components/tabled-repeat/tabled-repeat"
import { RequestTabledRepeat } from "lib/@components/request-tabled-repeat"
import { Box, LinearProgress, Stack, Typography } from "@mui/material"
import { NoResults } from "lib/@components/no-results/no-results"

export const TaskListToolbar = createSlot("TaskListToolbar")
const taskTableHeaders = [
    { title: "Name" },
    { title: "Duration", sx: { textAlign: "center" } },
    { title: "Frequency", sx: { textAlign: "center" } },
    { title: "Skillset" },
    { title: "" },
    { title: "" },
]

export function AuthoringTaskList({
    tasks,
    tableHeaders = taskTableHeaders,
    itemComponent = <AuthoringTaskItem />,
    loading,
    sx = {},
    requestPageRepeatProps,
}) {
    if (loading) {
        return (
            <Stack spacing={1} sx={{ py: 2 }} data-cy="task-similarity-loading">
                <Typography variant="body2" color="text.secondary">
                    Searching for tasks...
                </Typography>
                <LinearProgress color="primary" />
            </Stack>
        )
    }
    if (!tasks) return null
    if (!requestPageRepeatProps && tasks.length === 0) return <NoResults />

    let taskTable = (
        <TabledRepeat
            items={tasks}
            itemComponent={itemComponent}
            paged
            tableHeaders={tableHeaders}
            alternating={false}
            headerStyles={{ backgroundColor: "background.paper" }}
            sx={sx}
        />
    )
    if (requestPageRepeatProps) {
        taskTable = (
            <RequestTabledRepeat
                items={tasks}
                itemComponent={itemComponent}
                tableHeaders={tableHeaders}
                alternating={false}
                headerStyles={{ backgroundColor: "background.paper" }}
                sx={sx}
                {...requestPageRepeatProps}
            />
        )
    }

    return (
        <Bound>
            <Box display="flex" sx={{ justifyContent: "space-between", alignItems: "center" }}>
                <TaskListToolbar.Slot type="left" />
                <TaskListToolbar.Slot type="right" />
            </Box>
            <Box>{taskTable}</Box>
        </Bound>
    )
}
